import React from 'react';
function DashboardPage() {
  return <h1>Dashboard Page</h1>;
}
export default DashboardPage;